import { Features } from "@storytell/cp-client";

export const getModelDisplayName = (feature?: Features.Feature): string => {
  if (!feature) return "";

  const modelMap: Partial<Record<Features.Feature, string>> = {
    // Storytell Models
    [Features.Feature.MODEL_STORYTELL_AUTO_SELECT]: "Auto Select",
    [Features.Feature.MODEL_STORYTELL_RULESET]: "Storytell Ruleset",
    [Features.Feature.MODEL_STORYTELL_CURATED]: "Storytell Curated",
    [Features.Feature.MODEL_STORYTELL_AGENT_V3]: "Storytell Agent v3",

    // Anthropic Models
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_35_SONNET]: "Claude 3.5 Sonnet",
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_37_SONNET]: "Claude 3.7 Sonnet",
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_37_SONNET_THINKING]: "Claude 3.7 Sonnet (Thinking)",
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_4_SONNET]: "Claude 4 Sonnet",
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_4_SONNET_THINKING]: "Claude 4 Sonnet",
    [Features.Feature.MODEL_ANTHROPIC_CLAUDE_45_SONNET]: "Claude 4.5 Sonnet",

    // OpenAI Models
    [Features.Feature.MODEL_OPENAI_GPT_41]: "GPT-4.1",
    [Features.Feature.MODEL_OPENAI_GPT_41_MINI]: "GPT-4.1 Mini",
    [Features.Feature.MODEL_OPENAI_GPT_41_NANO]: "GPT-4.1 Nano",
    [Features.Feature.MODEL_OPENAI_03]: "o3",
    [Features.Feature.MODEL_OPENAI_04_MINI]: "o4 Mini",
    [Features.Feature.MODEL_OPENAI_GPT_5]: "GPT-5",
    [Features.Feature.MODEL_OPENAI_GPT_5_MINI]: "GPT-5 Mini",
    [Features.Feature.MODEL_OPENAI_GPT_5_NANO]: "GPT-5 Nano",

    // Google Models
    [Features.Feature.MODEL_GOOGLE_GEMINI_20_FLASH_LITE]: "Gemini 2.0 Flash Lite",
    [Features.Feature.MODEL_GOOGLE_GEMINI_25_PRO]: "Gemini 2.5 Pro",
    [Features.Feature.MODEL_GOOGLE_GEMINI_25_FLASH]: "Gemini 2.5 Flash",
    [Features.Feature.MODEL_GOOGLE_GEMINI_25_FLASH_THINKING]: "Gemini 2.5 Flash (Thinking)",

    // Meta Models
    [Features.Feature.MODEL_META_LLAMA_3370B_VERSATILE]: "Llama 3 370B",
    [Features.Feature.MODEL_META_LLAMA_4_SCOUT]: "Llama 4 Scout",
    [Features.Feature.MODEL_META_LLAMA_4_MAVERICK]: "Llama 4 Maverick",

    // DeepSeek Models
    [Features.Feature.MODEL_DEEPSEEK_R1_DISTILL_LLAMA_70B]: "DeepSeek R1 Llama 70B",
    [Features.Feature.MODEL_DEEPSEEK_R1_DISTILL_QWEN_7B]: "DeepSeek R1 Qwen 7B",
  };

  return modelMap[feature] || "";
};
